// @flow

export class FeatureFlagService {
  static shouldShowOnStaging (): boolean {
    return (FeatureFlagService.isOnStaging() || FeatureFlagService.isOnLocal()) && !FeatureFlagService.isSimulatingProduction()
  }

  static shouldShowOnProduction (): boolean {
    return FeatureFlagService.isOnProduction()
  }

  static isOnProduction (): boolean {
    return window.location.hostname === 'app.chatchamp.com' || FeatureFlagService.isSimulatingProduction()
  }

  static isOnStaging (): boolean {
    return window.location.hostname === 'app-staging.chatchamp.com'
  }

  static isOnLocal (): boolean {
    return window.location.hostname === 'app.chatchamp.local'
  }

  static isSimulatingProduction (): boolean {
    return window.localStorage.getItem('simulate_production') === 'true'
  }
}
